import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30c23d6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topban" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zhengque" }, "重度特应性皮炎诊疗笔记")
], -1))
const _hoisted_3 = { class: "ding" }
const _hoisted_4 = { class: "biji1" }
const _hoisted_5 = { class: "bjbtn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      style: {"top":"50%"}
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_image, {
              width: "7.6667rem",
              height: "10.9867rem",
              src: require('../assets/biji1.png')
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_van_image, {
                width: "8.5rem",
                height: "2rem",
                src: require('../assets/footBtn.png')
              }, null, 8, ["src"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_toNav, { menu: 5 })
  ], 64))
}